var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinkTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 10,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22V57H10C4.47715 57 0 52.5228 0 47V10Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22V57H10C4.47715 57 0 52.5228 0 47V10Z",
    fill: "#5C0048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H57V10C57 4.47715 52.5228 0 47 0H22V20Z",
    fill: "#F562D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkTheme);
export default __webpack_public_path__ + "static/media/pink-theme.6083af82721d9e6530e8081654d85465.svg";
export { ForwardRef as ReactComponent };